export default __webpack_public_path__ + "static/media/Netwroking-Professionally.2006b1a6.pdf";